import { Button, Modal, Typography } from "antd";
import useViewport from "components/UseViewport/UseViewport";
import React, { useState } from "react";
import { StyledList, StyledItem, StyledText } from "./style";

const { Title } = Typography;

interface Props {
  closeTime: string;
}

const CodeOfConduct: React.FC<Props> = ({ closeTime }) => {
  const [open, setOpen] = useState(false);
  const { width } = useViewport();
  const breakpoint = 900;

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        style={{
          width: width < breakpoint ? "100%" : "95%",
          border: `1px solid var(--font-color)`,
          color: "var(--font-color)",
        }}
      >
        Se hele ordensreglementet
      </Button>
      <Modal
        title={<Title level={4}>Ordensreglement</Title>}
        centered
        open={open}
        width={width < breakpoint ? "95vw" : "60vw"}
        onCancel={() => setOpen(false)}
        footer={
          <Button key="submit" type="primary" onClick={() => setOpen(false)}>
            Lukk
          </Button>
        }
        okText="Lukk"
        bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}
      >
        <Title level={5}>Før presentasjonen</Title>
        <StyledList>
          <StyledItem>Alle må registrere seg med eget brukernavn.</StyledItem>
          <StyledItem>Møt presis. Dørene til dette arrangementet stenger kl. {closeTime}.</StyledItem>
        </StyledList>
        <Title level={5}>Under presentasjonen</Title>
        <StyledList>
          <StyledItem>Mobilbruk er ikke tillatt.</StyledItem>
          <StyledItem>Det er ikke tillatt å forlate rommet.</StyledItem>
        </StyledList>
        <Title level={5}>Bespisning</Title>
        <StyledList>
          <StyledItem>Reservert-lapper skal ikke flyttes.</StyledItem>
          <StyledItem>Oppfør deg vennlig ovenfor bedriftsrepresentanter og medstudenter.</StyledItem>
        </StyledList>
        <br />
        <StyledText strong>Vi forbeholder oss retten å gi prikk basert på skjønn.</StyledText>
      </Modal>
    </>
  );
};

export default CodeOfConduct;
